import { render, staticRenderFns } from "./supplierManage.vue?vue&type=template&id=1d654e13&scoped=true"
import script from "./supplierManage.vue?vue&type=script&lang=js"
export * from "./supplierManage.vue?vue&type=script&lang=js"
import style0 from "./supplierManage.vue?vue&type=style&index=0&id=1d654e13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d654e13",
  null
  
)

export default component.exports